import { render, staticRenderFns } from "./PropertiesWrapper.vue?vue&type=template&id=c4d11742&"
import script from "./PropertiesWrapper.vue?vue&type=script&lang=js&"
export * from "./PropertiesWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesWrapper.vue?vue&type=style&index=0&id=c4d11742&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports